import { gql } from 'apollo-angular'

export const ADD_DOMAINNAME = gql`
  mutation AddDomainName($organizationId: Int!, $domain: String!) {
    createOrganizationDomain(
      data: { organization: $organizationId, domain: $domain }
    ) {
      id
    }
  }
`
